import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedPipesModule } from '@max/shared/pipes/shared-pipes.module';
import { SharedModule } from '@max/shared/shared.module';
import { TableModule } from 'primeng/table';
import { MotorCarrierAccountTPAFeeSummaryModalComponent } from './motor-carrier-account-tpa-fee-summary-modal.component';

@NgModule({
    declarations: [
        MotorCarrierAccountTPAFeeSummaryModalComponent
    ],
    imports: [
        SharedModule,
        CommonModule,
        SharedPipesModule,
        ReactiveFormsModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        TableModule
    ],
    exports: [
        MotorCarrierAccountTPAFeeSummaryModalComponent
    ]
})
export class MotorCarrierAccountTPAFeeSummaryModalModule {
}
